"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Close_1 = tslib_1.__importDefault(require("@mui/icons-material/Close"));
const Error_1 = tslib_1.__importDefault(require("@mui/icons-material/Error"));
const material_1 = require("@mui/material");
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Card_1 = tslib_1.__importDefault(require("@mui/material/Card"));
const CardActions_1 = tslib_1.__importDefault(require("@mui/material/CardActions"));
const CardContent_1 = tslib_1.__importDefault(require("@mui/material/CardContent"));
const CardHeader_1 = tslib_1.__importDefault(require("@mui/material/CardHeader"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const snackbarUtils_1 = require("../snackbarUtils");
const getStyles = ({ theme }) => ({
    card: {
        borderRadius: theme.shape.borderRadius,
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))",
        backgroundColor: theme.palette.error.main,
    },
    icon: {
        display: "flex",
        color: theme.palette.error.main,
    },
    header: {
        padding: theme.spacing(2),
    },
    headerActions: {
        marginTop: "0px",
        marginRight: "0px",
    },
    content: {
        "& .MuiCardContent-root": {
            padding: theme.spacing(2),
            paddingTop: "0px",
            overflow: "auto",
            paddingBottom: theme.spacing(2),
            paddingLeft: theme.spacing(7),
            "&:last-child": {
                paddingBottom: theme.spacing(2),
            },
        },
    },
    message: {
        width: "350px",
        maxHeight: "25vh",
        overflowWrap: "break-word",
    },
    cardActions: {
        justifyContent: "flex-end",
        paddingTop: "0px",
        paddingBottom: "0px",
    },
    noPadding: {
        padding: "0px",
    },
});
const SnackbarErrorWithTitle = react_1.default.forwardRef((props, ref) => {
    const { key, message, title, contactUs, actionButton, closeSnackbar } = props;
    const theme = (0, material_1.useTheme)();
    const styles = getStyles({ theme });
    return (react_1.default.createElement(Card_1.default, { ref: ref, key: key, sx: styles.card },
        react_1.default.createElement(CardHeader_1.default, { sx: {
                "& .MuiCardHeader-root": { p: 2 },
                "& .MuiCardHeader-avatar": { display: "flex", color: theme.palette.error.main },
                "& .MuiCardHeader-action": { mt: 0, mr: 0 },
            }, title: title, avatar: react_1.default.createElement(Error_1.default, null), action: react_1.default.createElement(IconButton_1.default, { sx: styles.noPadding, size: "small", onClick: closeSnackbar },
                react_1.default.createElement(Close_1.default, null)), titleTypographyProps: { variant: "subtitle1" } }),
        react_1.default.createElement(CardContent_1.default, { sx: styles.content },
            react_1.default.createElement(Typography_1.default, { variant: "body2", sx: styles.message }, message)),
        Boolean(actionButton || contactUs) && (react_1.default.createElement(CardActions_1.default, { sx: styles.cardActions },
            actionButton && (react_1.default.createElement(Button_1.default, { size: "small", onClick: actionButton.onClick }, actionButton.buttonText)),
            contactUs && (react_1.default.createElement(Button_1.default, { size: "small", href: (0, snackbarUtils_1.createContactUsEmailLink)(contactUs.errorDetails) }, contactUs.buttonText))))));
});
exports.default = SnackbarErrorWithTitle;
